import { ItemNotPlayableYet } from '@mimir/common/types/knownErrors';

export interface SerializedErrorGeneric {
  type: 'generic',
  name: string,
  message: string,
  stack: string | undefined,
  cause: SerializedError | undefined,
}

export interface SerializedErrorItemNotPlayableYet {
  type: 'item_not_playable_yet',
}

export interface SerializedErrorUnknown {
  type: 'unknown',
}

export type SerializedError =
  SerializedErrorGeneric |
  SerializedErrorItemNotPlayableYet |
  SerializedErrorUnknown;


export function serializeError(e: unknown): SerializedError {
  if (e instanceof ItemNotPlayableYet) {
    return { type: 'item_not_playable_yet' };
  }
  if (e instanceof Error) {
    return {
      type: 'generic',
      message: e.message,
      name: e.name,
      stack: e.stack,
      cause: e.cause ? serializeError(e.cause) : undefined,
    };
  }

  return { type: 'unknown' };
}

export function deserializeError(serialized: SerializedError): unknown {
  switch (serialized.type) {
    case 'generic': {
      const cause = serialized.cause ? deserializeError(serialized.cause): undefined;
      const error = new Error(serialized.message, { cause });
      error.stack = serialized.stack;
      error.name = serialized.name;
      return error;
    }
    case 'item_not_playable_yet': {
      return new ItemNotPlayableYet();
    }
    case 'unknown': {
      return new Error('Unknown error');
    }
  }
}
